/**
 * It removes the href attribute from the product image link and adds a touchstart event listener to
 * it. If the user touches the image once, the href attribute is removed. If the user touches the image
 * twice, the href attribute is added back
 * So the user will see the hover image and wish button
 */
function showCustomWishList() {
  const isTouchDevice = "ontouchstart" in document.documentElement;
  const mainCollectionProductGrid = document.querySelector("#main-collection-product-grid");

  function handleTouchStart(event) {
    let numTouches = parseInt(this.getAttribute("data-touches")) || 0;
    if (numTouches === 0) {
      this.setAttribute("data-touches", numTouches + 1);
    } else {
      this.setAttribute("href", this.getAttribute("data-href"));
    }
  }

  function handleMouseLeave() {
    this.setAttribute("data-touches", "0");
  }

  function processNode(node) {
    let imageCardHref = node.querySelector("a.img-link");

    if (imageCardHref && isTouchDevice) {
      const hrefValue = imageCardHref.getAttribute("href");
      const dataHrefValue = imageCardHref.getAttribute("data-href");

      if (!dataHrefValue && hrefValue) {
        imageCardHref.setAttribute("data-href", hrefValue);
        imageCardHref.removeAttribute("href");
      }

      imageCardHref.addEventListener("touchstart", handleTouchStart);
      imageCardHref.addEventListener("mouseleave", handleMouseLeave);
    }
  }

  Array.from(mainCollectionProductGrid.children).forEach(processNode);
}


/**
 * The function restores the height of a list of elements and returns a promise that resolves after a
 * simulated async work.
 * @param elements - an array of DOM elements whose height needs to be restored to 100%.
 * @returns A Promise object is being returned.
 */
function restoreHeight(elements) {
  return new Promise((resolve) => {
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.height = "100%";
    }
    // Use a timeout to simulate some async work
    setTimeout(() => {
      resolve();
    }, 1000);
  });
}

/**
 * The function sets the same height for a group of elements based on their media query and group size.
 * @returns If there are no elements with the class "img-label", the function will return nothing
 * (undefined).
 */
async function setSameHeight(filter = null) {
  const elements = document.querySelectorAll(".img-label");
  if (elements.length === 0) return;

  if (filter) {
    await restoreHeight(elements);
  }

  const mediaQueries = {
    "(max-width: 768px)": { groupSize: 2 },
    "(min-width: 769px) and (max-width: 900px)": { groupSize: 3 },
    "(min-width: 901px)": { groupSize: 4 },
  };

  Object.entries(mediaQueries).forEach(([query, config]) => {
    if (window.matchMedia(query).matches) {
      const groups = groupElements(elements, config.groupSize);
      const heights = getGroupHeights(groups);
      const averageHeight = getAverageHeight(heights);
      setElementHeights(groups, heights, averageHeight);
    }
  });
}

/**
 * The function groups elements into arrays of a specified size.
 * @param elements - an array of elements to be grouped
 * @param groupSize - `groupSize` is a parameter that determines the number of elements to be grouped
 * together in each sub-array. For example, if `groupSize` is 3 and the input array has 10 elements,
 * the output will be an array of sub-arrays, each containing 3 elements (except
 * @returns an array of arrays, where each inner array contains a group of elements from the original
 * array. The size of each group is determined by the `groupSize` parameter. If the original array is
 * not evenly divisible by `groupSize`, the last group may contain fewer elements.
 */
function groupElements(elements, groupSize) {
  const groups = [];
  for (let i = 0; i < elements.length; i += groupSize) {
    const group = [];
    for (let j = 0; j < groupSize; j++) {
      const element = elements[i + j];
      if (element) group.push(element);
    }
    groups.push(group);
  }
  return groups;
}

/**
 * This function takes an array of groups and returns an array of the maximum height of each group's
 * elements.
 * @param groups - The `groups` parameter is an array of arrays, where each inner array represents a
 * group of HTML elements.
 * @returns The function `getGroupHeights` returns an array of numbers representing the maximum height
 * of each group of elements passed as an argument.
 */
function getGroupHeights(groups) {
  return groups.map((group) => Math.max(...group.map((el) => el.offsetHeight)));
}

/**
 * The function calculates the average height from an array of heights.
 * @param heights - The parameter "heights" is an array of numbers representing the heights of a group
 * of people. The function "getAverageHeight" calculates the average height of the group by adding up
 * all the heights in the array and dividing by the number of heights in the array.
 * @returns the average height of an array of heights. It calculates the sum of all heights using the
 * `reduce()` method and then divides it by the length of the array to get the average height.
 */
function getAverageHeight(heights) {
  return heights.reduce((sum, height) => sum + height) / heights.length;
}

/**
 * This function sets the height of elements in groups based on either predefined heights or an average
 * height.
 * @param groups - an array of arrays, where each inner array represents a group of elements that
 * should have the same height
 * @param heights - An array of numbers representing the desired height for each group of elements. The
 * length of this array should be equal to the number of groups.
 * @param averageHeight - The average height that each element in a group should be set to if the group
 * does not have the same number of elements as the other groups.
 */
function setElementHeights(groups, heights, averageHeight) {
  groups.forEach((group, index) => {
    const newHeight =
      group.length === groups[0].length ? heights[index] : averageHeight;
    group.forEach((el) => (el.style.height = `${newHeight}px`));
  });
}